import React, { useEffect } from "react";
import About from "../sections/About";
import Skills from "../sections/Skills";
import Certifications from "../sections/Certifications";
import Experience from "../sections/Experience";
import Projects from "../sections/Projects";
import Footer from "../sections/Footer";

function HomeSections({ setShowHero }) {
  useEffect(() => {
    setShowHero(true);
  }, [setShowHero]);

  return (
    <>
      <About />
      <Skills />
      <Certifications />
      <Experience />
      <Projects />
      <Footer />
    </>
  );
}

export default HomeSections;
